import LazyLoad from './lazy-load';
import Flickity from 'flickity';
/**
 * Slider component.
 * All DOM elements with classname '.js-slider' will be Flickified.
 *
 * Usage:
 * Call Slider.init() to initialize all sliders..
 *
 * Methods:
 *
 * init(): initializes on all $sliders
 */

const slider = function() {
	const getSlideDelay = $slide => {
		const delay = $slide.getAttribute('data-slide-delay');
		return delay ? parseInt(delay, 10) : 3000;
	};

	const $sliders = document.querySelectorAll('.js-slider');
	$sliders.forEach($slider => {
		const $slides = $slider.querySelectorAll('.slider-slide');
		// eslint-disable-next-line no-new
		const slider = new Flickity($slider, {
			wrapAround: true,
			draggable: true,
			prevNextButtons: false,
			pageDots: $slides.length > 1,
			autoPlay: getSlideDelay($slides[0]),
			pauseAutoPlayOnHover: true
		});

		slider.on('change', () => {
			const $activeSlide = $slides[slider.selectedIndex];
			// set autoplay delay to the new active slide
			slider.options.autoPlay = getSlideDelay($activeSlide);
			// Lazyload new active slide
			LazyLoad.init($activeSlide, true);
		});

		// We had to use a separate slider for the background images,
		// since they need to be full viewport width and the sliders are not.
		const bgSliderId = $slider.getAttribute('data-bg-slider-id');
		if (bgSliderId) {
			const $bgSlider = document.getElementById(bgSliderId);
			if (!$bgSlider) return;

			const bgslider = new Flickity($bgSlider, {
				wrapAround: true,
				draggable: false,
				prevNextButtons: false,
				autoPlay: false,
				pageDots: false,
			});
			// When slider changes, also change bgslider.
			slider.on('select', () => { 
				bgslider.select(slider.selectedIndex);
			});
		}
	});
};

export default {
	init: slider
};
